import Meter from "components/Meter";
import { formatCompactCurrency } from "utils/currency";

import styles from "./PipelineValueByCustomerModal.module.scss";

const SHARE_MAX = 100;
const SHARE_BAR_HEIGHT = 8;

const getRankClass = (index) => {
  if (index === 0) {
    return styles["pipelineValueByCustomerModal__shareFill--rank1"];
  }
  if (index === 1) {
    return styles["pipelineValueByCustomerModal__shareFill--rank2"];
  }
  if (index === 2) {
    return styles["pipelineValueByCustomerModal__shareFill--rank3"];
  }
  return styles["pipelineValueByCustomerModal__shareFill--rest"];
};

export const createColumns = (topLevelCurrency) => [
  {
    header: "Customer",
    accessorKey: "customerName",
    id: "customerName",
    enableSorting: false,
    cell: ({ row }) => (
      <span title={row.original.customerName}>
        {row.original.customerName}
      </span>
    ),
  },
  {
    header: "Share of Pipeline",
    accessorKey: "percentageOfTotal",
    id: "percentageOfTotal",
    enableSorting: false,
    cell: ({ row }) => {
      const pct = row.original.percentageOfTotal;
      return (
        <div className={styles.pipelineValueByCustomerModal__share}>
          <div className={styles.pipelineValueByCustomerModal__shareBar}>
            <Meter
              id={`pipeline-share-${row.index}`}
              max={SHARE_MAX}
              progressClassName={getRankClass(row.index)}
              showLabel={false}
              size={SHARE_BAR_HEIGHT}
              value={pct}
            />
          </div>
          <span>{Math.round(pct)}%</span>
        </div>
      );
    },
  },
  {
    header: "Pipeline Value",
    accessorKey: "value",
    id: "value",
    enableSorting: false,
    cell: ({ row }) => (
      <span className={styles.pipelineValueByCustomerModal__valueCell}>
        {formatCompactCurrency(
          row.original.value,
          row.original.currency ?? topLevelCurrency
        )}
      </span>
    ),
  },
];
